import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const LeadgeneratieCTA = () => {
  return (
    <section className="bg-brand-lightBlue py-12">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-brand-blue font-bold tracking-wider text-sm mb-2">CONSISTENCY WINS.</p>
          <h2 className="text-3xl font-bold mb-4 text-gray-900">
            Resultaat volgt uit consequente uitvoering.
          </h2>
          <p className="text-lg text-gray-700 mb-6">
            Ontdek hoe we commerciële systemen bouwen voor B2B-organisaties die op lange termijn willen winnen.
          </p>
          <Link 
            to="/leadgeneratie-kmo" 
            className="btn-primary inline-flex items-center gap-2"
          >
            Bekijk succesverhalen
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LeadgeneratieCTA;
